/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EngineType } from './EngineType';
import {
    EngineTypeFromJSON,
    EngineTypeFromJSONTyped,
    EngineTypeToJSON,
    EngineTypeToJSONTyped,
} from './EngineType';
import type { ProcurementType } from './ProcurementType';
import {
    ProcurementTypeFromJSON,
    ProcurementTypeFromJSONTyped,
    ProcurementTypeToJSON,
    ProcurementTypeToJSONTyped,
} from './ProcurementType';
import type { VehicleStatus } from './VehicleStatus';
import {
    VehicleStatusFromJSON,
    VehicleStatusFromJSONTyped,
    VehicleStatusToJSON,
    VehicleStatusToJSONTyped,
} from './VehicleStatus';

/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Vehicle
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Vehicle
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    vehicleTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    serialNumber: string;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    manufactureYear?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    departmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    shockProfileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    phoneImei?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    preOpsChecklistId?: string | null;
    /**
     * 
     * @type {ProcurementType}
     * @memberof Vehicle
     */
    procurementType?: ProcurementType | null;
    /**
     * 
     * @type {Date}
     * @memberof Vehicle
     */
    purchaseDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    purchaseCost?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Vehicle
     */
    contractTermStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Vehicle
     */
    contractTermEnd?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    monthlyCost?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    initialOperatingHours: number;
    /**
     * This already includes the initial operating hours.
     * @type {number}
     * @memberof Vehicle
     */
    totalOperatingSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    idleAutoLogoutAfter?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    maintenanceInterval: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    maintenanceNotificationAt?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    maintenanceLockdown: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    checklistOverride: boolean;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    weeklyDriveGoalHours?: number | null;
    /**
     * This value is refreshed whenever the fleet authenticate period table updates. We maintain multiple database triggers for this: - `add_login_time` - `update_login_time` - `remove_login_time`
     * @type {number}
     * @memberof Vehicle
     */
    totalLoginSeconds: number;
    /**
     * This value is refreshed whenever the vehicle movement period table updates. We maintain multiple database triggers for this: - `add_drive_time` - `update_drive_time` - `remove_drive_time`
     * @type {number}
     * @memberof Vehicle
     */
    totalDriveSeconds: number;
    /**
     * This is calculated from vehicle maintenance table
     * @type {VehicleStatus}
     * @memberof Vehicle
     */
    status: VehicleStatus;
    /**
     * This comes from vehicle maintenance table
     * @type {Date}
     * @memberof Vehicle
     */
    lastMaintenanceDate?: Date | null;
    /**
     * This comes from vehicle maintenance table
     * @type {number}
     * @memberof Vehicle
     */
    lastMaintenanceOperatingHours?: number | null;
    /**
     * When maintenance table has no entry, this is calculated from initial operating hours
     * @type {number}
     * @memberof Vehicle
     */
    nextMaintenanceHours: number;
    /**
     * This is calculated
     * @type {number}
     * @memberof Vehicle
     */
    hoursUntilNextMaintenance: number;
    /**
     * 
     * @type {Date}
     * @memberof Vehicle
     */
    lastSynchronizedAt?: Date | null;
    /**
     * 
     * @type {EngineType}
     * @memberof Vehicle
     */
    engineType: EngineType;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    magneticFieldThreshold: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    motionStartThresholdMv: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    motionStopThresholdMv: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    motionStartDelayMs: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    motionStopDelayMs: number;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    speakerVolume?: number | null;
}



/**
 * Check if a given object implements the Vehicle interface.
 */
export function instanceOfVehicle(value: object): value is Vehicle {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('initialOperatingHours' in value) || value['initialOperatingHours'] === undefined) return false;
    if (!('totalOperatingSeconds' in value) || value['totalOperatingSeconds'] === undefined) return false;
    if (!('maintenanceInterval' in value) || value['maintenanceInterval'] === undefined) return false;
    if (!('maintenanceLockdown' in value) || value['maintenanceLockdown'] === undefined) return false;
    if (!('checklistOverride' in value) || value['checklistOverride'] === undefined) return false;
    if (!('totalLoginSeconds' in value) || value['totalLoginSeconds'] === undefined) return false;
    if (!('totalDriveSeconds' in value) || value['totalDriveSeconds'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('nextMaintenanceHours' in value) || value['nextMaintenanceHours'] === undefined) return false;
    if (!('hoursUntilNextMaintenance' in value) || value['hoursUntilNextMaintenance'] === undefined) return false;
    if (!('engineType' in value) || value['engineType'] === undefined) return false;
    if (!('magneticFieldThreshold' in value) || value['magneticFieldThreshold'] === undefined) return false;
    if (!('motionStartThresholdMv' in value) || value['motionStartThresholdMv'] === undefined) return false;
    if (!('motionStopThresholdMv' in value) || value['motionStopThresholdMv'] === undefined) return false;
    if (!('motionStartDelayMs' in value) || value['motionStartDelayMs'] === undefined) return false;
    if (!('motionStopDelayMs' in value) || value['motionStopDelayMs'] === undefined) return false;
    return true;
}

export function VehicleFromJSON(json: any): Vehicle {
    return VehicleFromJSONTyped(json, false);
}

export function VehicleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vehicle {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'model': json['model'] == null ? undefined : json['model'],
        'vehicleTypeId': json['vehicleTypeId'] == null ? undefined : json['vehicleTypeId'],
        'serialNumber': json['serialNumber'],
        'manufactureYear': json['manufactureYear'] == null ? undefined : json['manufactureYear'],
        'departmentId': json['departmentId'] == null ? undefined : json['departmentId'],
        'shockProfileId': json['shockProfileId'] == null ? undefined : json['shockProfileId'],
        'phoneImei': json['phoneImei'] == null ? undefined : json['phoneImei'],
        'preOpsChecklistId': json['preOpsChecklistId'] == null ? undefined : json['preOpsChecklistId'],
        'procurementType': json['procurementType'] == null ? undefined : ProcurementTypeFromJSON(json['procurementType']),
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'purchaseCost': json['purchaseCost'] == null ? undefined : json['purchaseCost'],
        'contractTermStart': json['contractTermStart'] == null ? undefined : (new Date(json['contractTermStart'])),
        'contractTermEnd': json['contractTermEnd'] == null ? undefined : (new Date(json['contractTermEnd'])),
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'initialOperatingHours': json['initialOperatingHours'],
        'totalOperatingSeconds': json['totalOperatingSeconds'],
        'idleAutoLogoutAfter': json['idleAutoLogoutAfter'] == null ? undefined : json['idleAutoLogoutAfter'],
        'maintenanceInterval': json['maintenanceInterval'],
        'maintenanceNotificationAt': json['maintenanceNotificationAt'] == null ? undefined : json['maintenanceNotificationAt'],
        'maintenanceLockdown': json['maintenanceLockdown'],
        'checklistOverride': json['checklistOverride'],
        'weeklyDriveGoalHours': json['weeklyDriveGoalHours'] == null ? undefined : json['weeklyDriveGoalHours'],
        'totalLoginSeconds': json['totalLoginSeconds'],
        'totalDriveSeconds': json['totalDriveSeconds'],
        'status': VehicleStatusFromJSON(json['status']),
        'lastMaintenanceDate': json['lastMaintenanceDate'] == null ? undefined : (new Date(json['lastMaintenanceDate'])),
        'lastMaintenanceOperatingHours': json['lastMaintenanceOperatingHours'] == null ? undefined : json['lastMaintenanceOperatingHours'],
        'nextMaintenanceHours': json['nextMaintenanceHours'],
        'hoursUntilNextMaintenance': json['hoursUntilNextMaintenance'],
        'lastSynchronizedAt': json['lastSynchronizedAt'] == null ? undefined : (new Date(json['lastSynchronizedAt'])),
        'engineType': EngineTypeFromJSON(json['engineType']),
        'magneticFieldThreshold': json['magneticFieldThreshold'],
        'motionStartThresholdMv': json['motionStartThresholdMv'],
        'motionStopThresholdMv': json['motionStopThresholdMv'],
        'motionStartDelayMs': json['motionStartDelayMs'],
        'motionStopDelayMs': json['motionStopDelayMs'],
        'speakerVolume': json['speakerVolume'] == null ? undefined : json['speakerVolume'],
    };
}

export function VehicleToJSON(json: any): Vehicle {
    return VehicleToJSONTyped(json, false);
}

export function VehicleToJSONTyped(value?: Vehicle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'manufacturer': value['manufacturer'],
        'model': value['model'],
        'vehicleTypeId': value['vehicleTypeId'],
        'serialNumber': value['serialNumber'],
        'manufactureYear': value['manufactureYear'],
        'departmentId': value['departmentId'],
        'shockProfileId': value['shockProfileId'],
        'phoneImei': value['phoneImei'],
        'preOpsChecklistId': value['preOpsChecklistId'],
        'procurementType': ProcurementTypeToJSON(value['procurementType']),
        'purchaseDate': value['purchaseDate'] == null ? value['purchaseDate'] : value['purchaseDate'].toISOString(),
        'purchaseCost': value['purchaseCost'],
        'contractTermStart': value['contractTermStart'] == null ? value['contractTermStart'] : value['contractTermStart'].toISOString(),
        'contractTermEnd': value['contractTermEnd'] == null ? value['contractTermEnd'] : value['contractTermEnd'].toISOString(),
        'monthlyCost': value['monthlyCost'],
        'initialOperatingHours': value['initialOperatingHours'],
        'totalOperatingSeconds': value['totalOperatingSeconds'],
        'idleAutoLogoutAfter': value['idleAutoLogoutAfter'],
        'maintenanceInterval': value['maintenanceInterval'],
        'maintenanceNotificationAt': value['maintenanceNotificationAt'],
        'maintenanceLockdown': value['maintenanceLockdown'],
        'checklistOverride': value['checklistOverride'],
        'weeklyDriveGoalHours': value['weeklyDriveGoalHours'],
        'totalLoginSeconds': value['totalLoginSeconds'],
        'totalDriveSeconds': value['totalDriveSeconds'],
        'status': VehicleStatusToJSON(value['status']),
        'lastMaintenanceDate': value['lastMaintenanceDate'] == null ? value['lastMaintenanceDate'] : value['lastMaintenanceDate'].toISOString(),
        'lastMaintenanceOperatingHours': value['lastMaintenanceOperatingHours'],
        'nextMaintenanceHours': value['nextMaintenanceHours'],
        'hoursUntilNextMaintenance': value['hoursUntilNextMaintenance'],
        'lastSynchronizedAt': value['lastSynchronizedAt'] == null ? value['lastSynchronizedAt'] : value['lastSynchronizedAt'].toISOString(),
        'engineType': EngineTypeToJSON(value['engineType']),
        'magneticFieldThreshold': value['magneticFieldThreshold'],
        'motionStartThresholdMv': value['motionStartThresholdMv'],
        'motionStopThresholdMv': value['motionStopThresholdMv'],
        'motionStartDelayMs': value['motionStartDelayMs'],
        'motionStopDelayMs': value['motionStopDelayMs'],
        'speakerVolume': value['speakerVolume'],
    };
}

